import React from 'react'
import PropTypes from 'prop-types'
import { AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES, SCORE_IDS } from '../../data/constants'
import { getDomainScore } from '../../data/reportModel'
import SectionHeading from '../../components/SectionHeading/SectionHeading'
import WhyThisMatters from '../../components/WhyThisMatters/WhyThisMatters'
import ConditionalAccess from './ConditionalAccess'
import Device from './Device'
import GlobalAdmins from './GlobalAdmins'
import Mfa from './Mfa'

export default function IdentityAccess({
  summary = {},
  data = {},
  domainScores = [],
  dataAvailability = [],
  conditionalAccessPolicies = [],
  conditionalAccessPoliciesIsLoading = false,
  conditionalAccessPoliciesIsError = false,
}) {
  return (
    <>
      <div {...AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES}>
        <SectionHeading
          id="identity-access"
          titleId="AI_RISK_REPORT.SECTION.IDENTITY.TITLE"
          questionId="AI_RISK_REPORT.SECTION.IDENTITY.QUESTION"
        />
        <WhyThisMatters bodyId="AI_RISK_REPORT.SECTION.IDENTITY.WHY" />
      </div>
      <GlobalAdmins
        admins={data.globalAdmins ?? []}
        score={getDomainScore(domainScores, SCORE_IDS.IDENTITY_ACCESS)}
        summary={summary}
      />
      <ConditionalAccess
        score={getDomainScore(domainScores, SCORE_IDS.CONDITIONAL_ACCESS)}
        summary={summary}
        policies={conditionalAccessPolicies}
        isLoading={conditionalAccessPoliciesIsLoading}
        isError={conditionalAccessPoliciesIsError}
      />
      <Mfa summary={summary} mfaUsers={data.mfaUsers ?? { total: 0, items: [] }} dataAvailability={dataAvailability} />
      <Device dataAvailability={dataAvailability} />
    </>
  )
}

const summaryPropType = PropTypes.shape({
  users: PropTypes.shape({
    total: PropTypes.number,
    globalAdmins: PropTypes.number,
    mfa: PropTypes.shape({
      assessed: PropTypes.number,
      registered: PropTypes.number,
      registeredPct: PropTypes.number,
      nonPhishingResistantCount: PropTypes.number,
    }),
  }),
  conditionalAccess: PropTypes.shape({
    total: PropTypes.number,
    enabled: PropTypes.number,
    reportOnly: PropTypes.number,
    enabledPct: PropTypes.number,
  }),
})

IdentityAccess.propTypes = {
  summary: summaryPropType,
  data: PropTypes.shape({
    globalAdmins: PropTypes.arrayOf(PropTypes.shape({})),
    mfaUsers: PropTypes.shape({
      total: PropTypes.number,
      items: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
  domainScores: PropTypes.arrayOf(PropTypes.shape({})),
  dataAvailability: PropTypes.arrayOf(PropTypes.shape({})),
  conditionalAccessPolicies: PropTypes.arrayOf(PropTypes.shape({})),
  conditionalAccessPoliciesIsLoading: PropTypes.bool,
  conditionalAccessPoliciesIsError: PropTypes.bool,
}
